// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { BaseResponseZendeskConfigChatFoundResponse } from '../../../types';

/**
 * cancelAuth
 *
 * @export
 * @tags zendesk-config-chat-controller
 * @link [PUT] /zendeskConfigs/chat/cancelAuth
 */
export function putZendeskConfigsChatCancelAuth(): Promise<BaseResponseZendeskConfigChatFoundResponse>;
export function putZendeskConfigsChatCancelAuth(
    options: ApiOptions<never, never>
): Promise<BaseResponseZendeskConfigChatFoundResponse>;
export function putZendeskConfigsChatCancelAuth(
    options?: ApiOptions<never, never>
): Promise<BaseResponseZendeskConfigChatFoundResponse> {
    return request<never, never, never>('/zendeskConfigs/chat/cancelAuth', {
        ...options,
        method: 'put',
        __$requestCalleeName: 'putZendeskConfigsChatCancelAuth',
    });
}

export const meta = [
    {
        tags: ['zendesk-config-chat-controller'],
        path: '/zendeskConfigs/chat/cancelAuth',
        method: 'put',
    },
];
